// Wraps a bare video <iframe> in the existing widget-media markup.
// Args:
//   @src   - iframe src URL
//   @size  - widget-media-wrap size modifier (e.g. 'huge', 'large')
//   @title - iframe title attribute (accessibility); defaults to 'Video player'
// Any additional HTML attributes (e.g. width) are forwarded to the <iframe> via ...attributes.
<template>
  <div class='widget-media-wrap {{@size}}'>
    <div class='widget-media-r'>
      <iframe src={{@src}} title={{if @title @title 'Video player'}} allowfullscreen ...attributes></iframe>
    </div>
  </div>
</template>
